import { render, staticRenderFns } from "./BackgroundColorSelector.vue?vue&type=template&id=0a3bf2d7&scoped=true"
import script from "./BackgroundColorSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundColorSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundColorSelector.vue?vue&type=style&index=0&id=0a3bf2d7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bf2d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3bf2d7')) {
      api.createRecord('0a3bf2d7', component.options)
    } else {
      api.reload('0a3bf2d7', component.options)
    }
    module.hot.accept("./BackgroundColorSelector.vue?vue&type=template&id=0a3bf2d7&scoped=true", function () {
      api.rerender('0a3bf2d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/BackgroundColorSelector.vue"
export default component.exports